import {
  CAMPOS_PRODUTOS, CAMPOS_CLIENTES, CAMPOS_ALIQUOTAS, ROTULOS_CAMPO, donoDoCampo,
} from '../../importacao/mapeamento'

interface Props {
  tipo: 'produtos' | 'clientes' | 'aliquotas'
  colunas: string[]
  amostra: string[] // primeira linha de dados, para conferencia visual
  mapa: Record<string, string>
  aoMudar: (mapa: Record<string, string>) => void
}

export default function MapeamentoColunas({ tipo, colunas, amostra, mapa, aoMudar }: Props) {
  const campos =
    tipo === 'produtos' ? CAMPOS_PRODUTOS : tipo === 'clientes' ? CAMPOS_CLIENTES : CAMPOS_ALIQUOTAS
  return (
    <div className="bg-white rounded-xl shadow-sm p-4 space-y-2">
      <h3 className="font-medium text-slate-800">O que é cada coluna?</h3>
      {/* Chave = POSICAO da coluna. Por nome, duas colunas de mesmo cabecalho
          dividiam a mesma entrada e mexer num <select> mexia no outro (e o
          `key` do React duplicava). Achado 4 do smoke de 2026-07-27. */}
      {colunas.map((coluna, i) => (
        <div key={i} className="flex items-center gap-2">
          {/* `min-w-0` e o que permite ao `truncate` funcionar dentro de um
              flex: sem ele o filho recusa encolher e empurra a linha. */}
          <div className="flex-1 min-w-0">
            <span className="block text-sm font-medium text-slate-700 truncate">{coluna}</span>
            <span className="block text-xs text-slate-400 truncate">ex.: {amostra[i] || '—'}</span>
          </div>
          {/* ⚠ A LARGURA FIXA E O CONSERTO, e nao enfeite. Um <select> sem
              largura se estica ate caber a OPCAO MAIS LONGA da lista: com as
              chaves cruas mais o aviso de campo tomado, isso passava de 300px,
              a caixa comia a linha inteira do celular e o nome da coluna do
              arquivo -- o dado que a pessoa precisa ler para decidir -- virava
              reticencias. Achado dela no smoke do beta, 16/08/2026.
              `shrink-0` impede o flex de devolver o problema por outro caminho. */}
          <select
            aria-label={`Coluna ${i + 1}: ${coluna}`}
            value={mapa[String(i)] ?? ''}
            onChange={(e) => {
              const novo = { ...mapa }
              if (e.target.value) novo[String(i)] = e.target.value
              else delete novo[String(i)]
              aoMudar(novo)
            }}
            className="w-36 shrink-0 border border-slate-300 rounded-lg px-2 py-1 text-sm"
          >
            <option value="">ignorar</option>
            {/* Campo ja tomado por OUTRA coluna fica desabilitado, dizendo por
                quem. Sem isso davam para mapear duas colunas no mesmo campo e a
                de baixo sobrescrevia a de cima calada. Achado 7.
                O aviso e curto ("(já usado)") em vez de repetir o nome da outra
                coluna: a lista aberta no celular tem a largura da tela, e o
                nome longo empurrava o rotulo do campo para fora. */}
            {campos.map((campo) => {
              const dono = donoDoCampo(mapa, campo)
              const tomado = dono !== null && dono !== i
              return (
                <option key={campo} value={campo} disabled={tomado}>
                  {ROTULOS_CAMPO[campo] ?? campo}
                  {tomado ? ' (já usado)' : ''}
                </option>
              )
            })}
          </select>
        </div>
      ))}
    </div>
  )
}
